export const initPhoneInputs = function (formElement) {
  const phoneInputs = formElement.querySelectorAll('[type=tel]')
  phoneInputs.forEach((phoneInput) => {
    let errorMsg = document.createElement('div')
    errorMsg.classList.add(`phone-input-error`)
    errorMsg.setAttribute(`data-for`, phoneInput.id)
    phoneInput.after(errorMsg)

    //clear input to prevent get undefined country code when user go back in history
    phoneInput.value = ''

    const itiInstance = window.intlTelInput(phoneInput)

    let spanElement = document.createElement('span')
    spanElement.classList.add('input-country-code')
    phoneInput.parentElement.appendChild(spanElement)

    let inputElement = document.createElement('input')
    inputElement.type = 'hidden'
    inputElement.name = phoneInput.name
    phoneInput.parentElement.appendChild(inputElement)

    let hiddenCountryCodeInput
    if (!formElement.querySelector('[name="phone_country_code"]')) {
      let phoneCountryCodeElement = document.createElement('input')
      phoneCountryCodeElement.type = 'hidden'
      phoneCountryCodeElement.name = 'phone_country_code'
      phoneInput.parentElement.appendChild(phoneCountryCodeElement)
      hiddenCountryCodeInput = phoneInput.parentElement.querySelector(`[type="hidden"][name="phone_country_code"]`)
    } else {
      hiddenCountryCodeInput = formElement.querySelector('[name="phone_country_code"]')
    }

    let selectedCountryDialCode = itiInstance.getSelectedCountryData().dialCode
    let hiddenPhoneInput = phoneInput.parentElement.querySelector(`[type="hidden"][name="${phoneInput.name}"]`)
    const countryCodeField = phoneInput.parentElement.querySelector('.input-country-code')
    countryCodeField.innerHTML = `+${selectedCountryDialCode}`
    hiddenPhoneInput.value = `+${selectedCountryDialCode}${phoneInput.value}`
    phoneInput.style.paddingLeft = `${55 + countryCodeField.offsetWidth}px`

    formElement.addEventListener('change', (event) => {
      updatePhoneInputs(phoneInput, hiddenPhoneInput, countryCodeField, itiInstance)
      updateHiddenCountryCodeInput(hiddenCountryCodeInput, itiInstance)
    });

    phoneInput.addEventListener('input', (event) => {
      updatePhoneInputs(event.target, hiddenPhoneInput, countryCodeField, itiInstance)
      updateHiddenCountryCodeInput(hiddenCountryCodeInput, itiInstance)
    });

    phoneInput.addEventListener("countrychange", function (event) {
      updatePhoneInputs(event.target, hiddenPhoneInput, countryCodeField, itiInstance)
      updateHiddenCountryCodeInput(hiddenCountryCodeInput, itiInstance)
    });

    window.addEventListener('modal-with-form-opened', function (event) {
      const phoneElementFromEvent = event.target.querySelector('[type=tel]')
      if (phoneElementFromEvent && phoneElementFromEvent.isEqualNode(phoneInput)) {
        updatePhoneInputs(phoneInput, hiddenPhoneInput, countryCodeField, itiInstance)
        updateHiddenCountryCodeInput(hiddenCountryCodeInput, itiInstance)
      }
    })
  })
}

function updatePhoneInputs(phoneInput, hiddenPhoneInput, countryCodeField, itiInstance) {
  const selectedCountryDialCode = itiInstance.getSelectedCountryData().dialCode
  phoneInput.value = phoneInput.value.replace(/[^0-9]/g, '')
  phoneInput.parentElement.querySelector('.input-country-code').innerHTML = `+${selectedCountryDialCode}`
  phoneInput.style.paddingLeft = `${55 + countryCodeField.offsetWidth}px`
  hiddenPhoneInput.value = `+${selectedCountryDialCode}${phoneInput.value}`
}

function updateHiddenCountryCodeInput(hiddenCountryCodeInput, itiInstance) {
  hiddenCountryCodeInput.value = itiInstance.getSelectedCountryData().dialCode
}

/**
 * Load dynamically libphonenumber-js script used for phone number validation and parameter reading in forms
 */
export const loadLibPhone = function () {
  if (!document.querySelector('#libPhoneNumberScript')) {
    let libPhoneNumberScript = document.createElement("script")

    libPhoneNumberScript.setAttribute("id", 'libPhoneNumberScript')
    libPhoneNumberScript.setAttribute("src", '//unpkg.com/libphonenumber-js@1.10.49/bundle/libphonenumber-max.js')
    libPhoneNumberScript.setAttribute("type", "text/javascript")
    document.body.appendChild(libPhoneNumberScript)

    // success event
    libPhoneNumberScript.addEventListener("load", () => {
      console.log("libphonenumber-js loaded")
    })
  }
}

export const checkEmailInputValidation = function (emailInput, callback) {
  const emailInputValue = emailInput.value.trim()
  if (emailInputValue.length >= 1 || emailInput.hasAttribute('data-required')) {
    const emailCheckerResult = window.emailChecker(emailInputValue)
    if (emailCheckerResult.length == 0) {
      callback(true, emailInput)
    } else {
      callback(false, emailInput, emailCheckerResult[0].corrected)
    }
  }
}

export const checkPhoneInputValidation = function (phoneInput, callback) {
  const phoneInputValue = phoneInput.value.replace(/[ \-\(\)]/g, '')
  if (phoneInputValue.length >= 1 || phoneInput.hasAttribute('data-required')) {
    if (phoneInputValue.length >= 8 && phoneInputValue.length <= 13) {
      callback(true, phoneInput)
    } else {
      callback(false, phoneInput)
    }
  }
}

export const setAutoSuggestionToInput = function (autoSuggestInput, jsonURL = '/data/companies.json') {
  const suggestionsListElement = autoSuggestInput.parentNode.querySelector("#suggestions")

  fetch(jsonURL)
    .then(response => response.json())
    .then(data => {
      setAutoSuggestionEventsToInput(autoSuggestInput, suggestionsListElement, data)
    })
    .catch(error => {
      console.error('Error fetching data:', error)
    })
}

function setAutoSuggestionEventsToInput(autoSuggestInput, suggestionsListElement, suggestionsData) {
  autoSuggestInput.addEventListener("keyup", () => {
    if (autoSuggestInput.value.length < 3) {
      suggestionsListElement.innerHTML = ""
      suggestionsListElement.style.display = "none"
      return
    }
    showSuggestions(autoSuggestInput, suggestionsListElement, suggestionsData, autoSuggestInput.value)
  })

  window.autoSuggestEventListenerAdded = window.autoSuggestEventListenerAdded || false

  // Hide suggestions on click outside input
  if (!window.autoSuggestEventListenerAdded) {
    document.addEventListener("click", (e) => {
      if (!e.target.matches("#autoSuggestInput")) {
        suggestionsListElement.style.display = "none"
      }
    })
    window.autoSuggestEventListenerAdded = true
  }
}

function highlightText(text, value) {
  const regex = new RegExp(value, "gi") // Create case-insensitive regex with global flag
  return text.replace(regex, match => `<b>${match}</b>`)
}

function showSuggestions(autoSuggestInput, suggestionsListElement, suggestionsData, value) {
  const filteredSuggestionsData = suggestionsData.filter(company => company.name.toLowerCase().includes(value.toLowerCase()))

  suggestionsListElement.innerHTML = ""
  let count = 0

  if (filteredSuggestionsData.length > 0) {
    filteredSuggestionsData.forEach(company => {
      if (count >= 5) {
        return
      }
      const suggestionItem = document.createElement("li")
      const highlightedName = highlightText(company.name, value)
      suggestionItem.innerHTML = highlightedName
      suggestionItem.addEventListener("click", () => {
        autoSuggestInput.value = company.name
        suggestionsListElement.innerHTML = ""
      })
      suggestionsListElement.appendChild(suggestionItem)
      count++
    })
    suggestionsListElement.style.display = "block"
  } else {
    suggestionsListElement.style.display = "none"
  }
}